<template>
  <div class="card-wrapper">
    <b-card v-for="paymentTerm in paymentTerms" :key="paymentTerm.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-100 mb-lg-0 mb-2 mr-2">
            {{ paymentTerm.name }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i
            @click="showInfoModal(paymentTerm.id)"
            class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"
          ></i>

          <i @click="handleDelete(paymentTerm.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editPaymentTermModal" ref="editPaymentTermModal" size="lg" :title="'Edit payment term'">
      <b-row v-if="!isLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.paymentTerms.selectLogo')">
                <b-form-file
                  v-model="editForm.logo"
                  accept="image/*"
                  @change="logoUploaded = !logoUploaded"
                ></b-form-file>
              </b-form-group>

              <div class="my-2 mb-4">
                <img
                  v-if="!logoUploaded && logoUrl !== null"
                  :src="`${apiUrl}${logoUrl}`"
                  class="object-cover"
                  draggable="false"
                  width="100"
                  height="100"
                  alt=""
                />
              </div>

              <b-form-group>
                <b-form-checkbox v-model="editForm.active">{{ $t('pages.paymentTerms.active') }}</b-form-checkbox>
              </b-form-group>

              <b-form-group :label="`${$t('pages.paymentTerms.name')} (EN)`">
                <b-form-input type="text" v-model="$v.editForm.nameEn.$model" :state="!$v.editForm.nameEn.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameEn.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="`${$t('pages.paymentTerms.name')} (RU)`">
                <b-form-input type="text" v-model="$v.editForm.nameRu.$model" :state="!$v.editForm.nameRu.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameRu.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editPaymentTermModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from '@/constants/config'
const { required } = require('vuelidate/lib/validators')

export default {
  props: {
    paymentTerms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      isLoading: false,
      logoUrl: null,
      logoUploaded: false,
      editForm: {
        nameEn: '',
        nameRu: '',
        logo: null,
        active: false
      },
      currentPaymentTerm: null
    }
  },
  validations: {
    editForm: {
      nameEn: { required },
      nameRu: { required }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editPaymentTermModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('paymentTerms/deletePaymentTerm', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editPaymentTermModal')
      this.$store.dispatch('paymentTerms/fetchPaymentTerm', { id, vm: this })
      this.currentPaymentTerm = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.editForm.nameEn,
          name_ru: this.editForm.nameRu,
          active: this.editForm.active ? 'yes' : 'no'
        }
        if (this.editForm.logo) {
          payload.logo = this.editForm.logo
        }

        this.$store.dispatch('paymentTerms/updatePaymentTerm', {
          payload,
          id: this.currentPaymentTerm,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.nameEn = ''
      this.editForm.nameRu = ''
      this.editForm.logo = null
      this.editForm.active = false
      this.currentPaymentTerm = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
